import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { VhViethasWebAPPEndUser } from 'vhwebapp';
import path from '../../../config/path/path.json'
@Component({
  selector: 'app-webapp-quotation-products-c001-user',
  templateUrl: './webapp-quotation-products-c001-user.component.html',
  styleUrls: ['./webapp-quotation-products-c001-user.component.scss']
})
export class WebappQuotationProductsC001UserComponent implements OnInit {
  @Input() routeParams: any;
  @Input() id_field: any;
  isMobile: boolean;
  public Data: any;

  constructor(
    private router: Router,
    public platform: Platform,
    private vhViethasWebAPPEndUser: VhViethasWebAPPEndUser
  ) {
    if (this.platform.is("desktop")) this.isMobile = false
    else this.isMobile = true
  }

  ngOnInit(): void {
    console.log(this.routeParams)
    // let name: string  = this.item.name;
    // this.getData()
  }
  ngOnChanges() {
    this.getData();
  }

  getData() {
    this.vhViethasWebAPPEndUser.getComponentContentsByFields('webapp_fields_c001_items', { id_webapp_fields_c001: { $eq: this.id_field }, webapp_products_hidden: { $eq: true }, webapp_products_display_quotation: { $eq: true } }, {}, {}, 0, 0)
      .then((response: any) => {
        if (response.vcode === 0) {
          //-----------your code-----------
          this.Data = response.data;
        }
      }, error => {
        console.log('error', error)
      })
  }
  nameFormatFn(_name): string {
    _name = _name.split("-").join(" ");
    return _name.split(" ").join("-");
  }
  gotoDetail(pro) {
    this.router.navigateByUrl(path.link + '/' + this.routeParams.id_field + '/' + pro._id)
  }
}
